import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FileProgressTakeover } from 'web-ui-components/lib/data/capture';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { HighlightTile } from 'web-ui-components/lib/molecules/tile';
import { Row } from 'web-ui-components/lib/global/layout';
import {
	getBatchProcessPercentageComplete,
	getIsBatchProcessingProgressOpen,
	getCurrentBatchSize,
} from '../../managePayee/states/selectors';
import content, { contentPropTypes } from './BatchProgressTakeover.content';
import withContent from '../../containers/withContent';

const mapState = (state) => ({
	batchProcessPercentageComplete: getBatchProcessPercentageComplete(state),
	isBatchProcessingProgressOpen: getIsBatchProcessingProgressOpen(state),
	currentBatchSize: getCurrentBatchSize(state),
});

const BatchProgressTakeover = ({
	content: { title, activityText, warningText, subTitle },
	batchProcessPercentageComplete,
	isBatchProcessingProgressOpen,
	currentBatchSize,
}) => (
	<Row>
		{isBatchProcessingProgressOpen && (
			<FileProgressTakeover
				titleText={title.replace('{{items}}', currentBatchSize)}
				isOpen={isBatchProcessingProgressOpen}
				percentage={batchProcessPercentageComplete}
				activityText={activityText}
			>
				<HighlightTile type="warning">
					<StandardBody isFlush>{warningText}</StandardBody>
				</HighlightTile>

				{subTitle.map((value) => (
					<StandardBody key={value}>{value}</StandardBody>
				))}
			</FileProgressTakeover>
		)}
	</Row>
);
BatchProgressTakeover.defaultProps = {
	isBatchProcessingProgressOpen: false,
	currentBatchSize: 0,
	batchProcessPercentageComplete: 0,
};
BatchProgressTakeover.propTypes = {
	batchProcessPercentageComplete: PropTypes.number,
	isBatchProcessingProgressOpen: PropTypes.bool,
	currentBatchSize: PropTypes.number,
	content: PropTypes.shape(contentPropTypes),
};

const contentWrapper = withContent({ content });

export const EnhancedBatchProgressTakeover = compose(connect(mapState), contentWrapper)(BatchProgressTakeover);
export { BatchProgressTakeover };
